// extracted by mini-css-extract-plugin
module.exports = {"personal-space-container":"settings_personal-space-container__3IbVE"};